import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';

import { SmsAggregator } from 'src/app/core/api/models';
import { SmsAggregatorImageWidth } from '../../system-management/group-price/shared/directives/sms-aggregator-image-width.directive';
import { SmsAggregatorImage } from '../../system-management/group-price/shared/directives/sms-aggregator-image.directive';
import { ElementRef } from '@angular/core';

@Component({
    selector: 'app-smart-sms-operators',
    templateUrl: './smart-sms-operators.component.html',
    styleUrls: ['./smart-sms-operators.component.scss'],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule,
        MatSlideToggleModule,
        SmsAggregatorImage,
        SmsAggregatorImageWidth,
    ]
})
export class SmartSmsOperatorsComponent implements OnInit {
  //#region properties

  elementRef=inject(ElementRef);

  operators: Array<SmsAggregator> = [];
  get SmsAggregator() {
    return SmsAggregator;
  }

  @Input() isExistsMCI: boolean = false;
  @Input() isExistsIrancell: boolean = false;
  @Input() isExistsRightel: boolean = false;
  @Input() isShowToggle: boolean = false;
  @Input() isDetailMode: boolean = false;
  @Input() selectedOperator: number;
  @Input() isRefreshPage: boolean = false;

  @Output('operators') output_operators: EventEmitter<Array<SmsAggregator>> =
    new EventEmitter();
  @Output('isRefreshPage') output_isRefreshPage: EventEmitter<boolean> =
    new EventEmitter();
  @Output('selectedOperator') output_selectedOperator: EventEmitter<number> =
    new EventEmitter();
  //#endregion

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isRefreshPage']) {
      const timeout = setTimeout(() => {
        const matSlideToggleInput = this.elementRef.nativeElement.querySelectorAll(`input`);
        matSlideToggleInput.forEach((element) => {
          const checked = (element as HTMLInputElement).checked;
          if (checked) {
            (element as HTMLElement).click();
            this.selectedOperator = SmsAggregator.NotValid;
          }
          this.operators = [];
          this.output_isRefreshPage.emit(false);
          clearTimeout(timeout);
        });
      }, 10);
    }
  }

  selectOperator(event, operator: SmsAggregator) {
    if (event.checked) this.operators.push(operator);
    else this.operators.splice(this.operators.indexOf(operator), 1);
    this.operators = this.operators.filter(
      (operator, index) => this.operators.indexOf(operator) == index
    );

    this.output_operators.emit(this.operators);
  }

  changeSelectedOperator(operator: SmsAggregator) {
    this.selectedOperator = operator;
    this.output_selectedOperator.emit(this.selectedOperator);
  }

  // change checkbox state
  selectOperatorChecked(className, operator: SmsAggregator) {
    if (this.isDetailMode) this.changeSelectedOperator(operator);

    if (!this.isShowToggle) return;

    const matSlideToggle = this.elementRef.nativeElement.querySelector(`${className}`);
    const smsAggregator = +matSlideToggle.getAttribute('data-sms-aggregator');

    const timeout = setTimeout(() => {
      const matSlideToggleInput = this.elementRef.nativeElement.querySelector(`${className} button`);

      (matSlideToggleInput as HTMLElement).click();

      const checked = !JSON.parse(
        (matSlideToggleInput as HTMLButtonElement).ariaChecked
      );
      const event = { checked };

      this.changeSelectedOperator(operator);
      this.selectOperator(event, smsAggregator);
      clearTimeout(timeout);
    }, 10);

    return;
  }
}
